import { createContext, useContext, useState, useEffect, useRef, useCallback } from "react";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const storedUser = localStorage.getItem("user");
            return storedUser ? JSON.parse(storedUser) : null;
        } catch (error) {
            console.error("Error parsing user data:", error);
            return null;
        }
    });

    const logoutTimerRef = useRef(null);

    // Logout Timer Function
    const resetTimer = useCallback(() => {
        if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
        logoutTimerRef.current = setTimeout(() => {
            logout();
        }, 30 * 60 * 1000); // 30 minutes
    }, []);

    // Effect to handle user session timeout on activity
    useEffect(() => {
        if (!user) return;

        const activityEvents = ["mousemove", "keydown", "scroll", "click"];
        activityEvents.forEach((event) => window.addEventListener(event, resetTimer));
        
        // Start initial timer
        resetTimer();

        return () => {
            if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
            activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, [user, resetTimer]);

    // Store user data in localStorage when changed
    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        }
    }, [user]);

    const login = (userData) => {
        setUser(userData);
    };

    const logout = () => {
        setUser(null);
        localStorage.clear(); // Clears all stored data, including user session
        if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
        window.location.href = "/";


    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);